// Types
import { WelcomeBonusCurrencyValues } from "types/WelcomeBonus";

export const welcomeBonusCurrencyValues: WelcomeBonusCurrencyValues = {
  AZN: {
    block1: "500 AZN",
    block2: "30 AZN",
    block3: "30 AZN",
    block4: ["20 AZN", "500 AZN"],
    block5: "20 AZN",
  },
  USD: {
    block1: "300 USD",
    block2: "15 USD",
    block3: "15 USD",
    block4: ["5 USD", "300 USD"],
    block5: "5 USD",
  },
  BDT: {
    block1: "২৭০০০ BDT",
    block2: "১৪০০ BDT",
    block3: "১৪০০ BDT",
    block4: ["৫০০ BDT", "২৭০০০ BDT"],
    block5: "৫০০ BDT",
  },
  INR: {
    block1: "23 000 INR",
    block2: "1 200 INR",
    block3: "1 200 INR",
    block4: ["300 INR", "23 000 INR"],
    block5: "300 INR",
  },
  PKR: {
    block1: "62 000 PKR",
    block2: "3 000 PKR",
    block3: "3 000 PKR",
    block4: ["1 000 PKR", "62 000 PKR"],
    block5: "1 000 PKR",
  },
  LKR: {
    block1: "LKR 75 000",
    block2: "LKR 4 500",
    block3: "LKR 4 500",
    block4: ["LKR 1 500", "LKR 75 000"],
    block5: "LKR 1 500",
  },
  UZS: {
    block1: "3 000 000 UZS",
    block2: "160 000 UZS",
    block3: "160 000 UZS",
    block4: ["30 000 UZS", "3 000 000 UZS"],
    block5: "30 000 UZS",
  },
  TRY: {
    block1: "5 000 TRY",
    block2: "260 TRY",
    block3: "260 TRY",
    block4: ["80 TRY", "5 000 TRY"],
    block5: "80 TRY",
  },
  MMK: {
    block1: "60 000 MMK",
    block2: "30 000 MMK",
    block3: "30 000 MMK",
    block4: ["10 000 MMK", "60 000 MMK"],
    block5: "10 000 MMK",
  },
  KZT: {
    block1: "140 000 KZT",
    block2: "7 000 KZT",
    block3: "7 000 KZT",
    block4: ["2 500 KZT", "140 000 KZT"],
    block5: "2 500 KZT",
  },
  KES: {
    block1: "20 000 KES",
    block2: "1 000 KES",
    block3: "1 000 KES",
    block4: ["600 KES", "20 000 KES"],
    block5: "600 KES",
  },
  EUR: {
    block1: "300 EUR",
    block2: "15 EUR",
    block3: "15 EUR",
    block4: ["5 EUR", "300 EUR"],
    block5: "5 EUR",
  },
};

export const countryCurrency = {
  AZ: "AZN",
  KZ: "KZT",
  BD: "BDT",
  LK: "LKR",
  UZ: "UZS",
  TR: "TRY",
  MM: "MMK",
  KE: "KES",
  EU: "EUR",
  PK: "PKR",
  IN: "INR",
  PT: "EUR",
};
